<!-- <p>not-found works!</p> -->
<div class="not_found_container" style="background-image: url({{notFoundData.image}});">
	<div class="not_found_inner">
		<h3>
			{{notFoundData.heading}}
		</h3>
		<p>
			{{notFoundData.paragraph}}
		</p>
		<button [routerLink]="[notFoundData.link]">
			{{notFoundData.buttonText}}
		</button>
	</div>
</div>
